import Swiper from '../common/custom-swiper/custom-swiper';

export default new class snippetVideoFormSlider {
  constructor() {
    this.sliderContainerSelector = 'video-snippet__container';
    this.slideSelector = 'video-snippet__slide';

    document.addEventListener('DOMContentLoaded', () => {
      this.handler();
    });
  }

  handler() {
    const sliders = document.querySelectorAll(`.${this.sliderContainerSelector}`);

    if (!sliders) return;

    sliders.forEach((el) => {
      this.init(el);
    });
  }

  init(slider) {
    const arTitles = [];
    const slides = slider.querySelectorAll(`.${this.slideSelector}`);

    slides.forEach((el) => {
      arTitles.push(el.getAttribute('data-title'));
    });

    this.blogSlider = new Swiper(`.${this.sliderContainerSelector}`, {
      slidesPerView: 1,
      breakpointsInverse: true,
      watchOverflow: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      speed: 700,
      loop: false,
      pagination: {
        el: '.video-snippet__pagination',
        clickable: true,
        renderBullet(index, className) {
          return `<span class="video-snippet__bullet ${className}">${arTitles[index]}</span>`;
        },
      },
    });
  }
}();
